require('/opt/odin/app/frontend/components/commented_questions/index.module.scss');module.exports = "../../app/cells/components/commented_questions/show.erb";